import { ProductDoc } from '@gooduncles/gu-app-schema/dist/commerce/product/product';
import { useDispatch, useSelector } from 'react-redux';

import { setSelectedInventory, setSelectedProduct } from '../slices/inventory';
import { RootState } from '../store';

export const useInventory = () => {
  const dispatch = useDispatch();
  const inventoryId = useSelector((state: RootState) => state.inventory.inventoryId);
  const product = useSelector((state: RootState) => state.inventory.product);
  const onSetSelectedInventory = (inventoryId: string | null) => {
    dispatch(setSelectedInventory(inventoryId));
  };

  const onSetSelectedProduct = (product: ProductDoc | null) => {
    dispatch(setSelectedProduct(product));
  };

  return {
    inventoryId,
    product,
    onSetSelectedInventory,
    onSetSelectedProduct,
  };
};
